import { __awaiter } from 'tslib';

const downloadFileFromUrl = (url, nameOfFile) => {
    const save = document.createElement("a");
    save.setAttribute("id", "download_link_for_custom_file");
    save.setAttribute("href", url);
    save.download = nameOfFile;
    document.body.appendChild(save);
    const elem = document.getElementById("download_link_for_custom_file");
    if (elem && document.createEvent) {
        const evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, false);
        elem.dispatchEvent(evt);
    }
    document.body.removeChild(save);
};
const downloadFileFromBuffer = (buffer, nameOfFile, type) => {
    const uint8Array = new Uint8Array(buffer);
    const blob = new Blob([uint8Array], { type });
    const url = URL.createObjectURL(blob);
    downloadFileFromUrl(url, nameOfFile);
};
const getFileFromUrl = (url_1, name_1, ...args_1) => __awaiter(void 0, [url_1, name_1, ...args_1], void 0, function* (url, name, defaultType = "image/jpeg") {
    try {
        const response = yield fetch(url);
        const data = yield response.blob();
        return new File([data], name, {
            type: data.type || defaultType,
        });
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
const blobToData = (blob) => {
    return new Promise((resolve) => {
        if (!blob || !(blob instanceof Blob)) {
            resolve(null);
            return;
        }
        try {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
        }
        catch (err) {
            console.log(err);
            resolve(null);
        }
    });
};
// Function to fetch image as blob
function fetchImageAsBlob(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch ${url}`);
        }
        return response.blob();
    });
}
// Function to extract file extension from URL
function getFileExtension(url) {
    const match = url.match(/\.[0-9a-z]+$/i);
    return match ? match[0] : ".jpg"; // Default to .jpg
}

export { blobToData, downloadFileFromBuffer, downloadFileFromUrl, fetchImageAsBlob, getFileExtension, getFileFromUrl };
